/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgArrowLinkDash = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M16.586 6H14V4h6v6h-2V7.414l-2.293 2.293-1.414-1.414zM5.707 19.707l1.5-1.5-1.414-1.414-1.5 1.5zm2.5-2.5 1.5-1.5-1.414-1.414-1.5 1.5zm2.5-2.5 1.5-1.5-1.414-1.414-1.5 1.5zm2.5-2.5 1.5-1.5-1.414-1.414-1.5 1.5z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgArrowLinkDash as ArrowLinkDash };
